<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('name')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-radio-group v-model="item.success" row :label="$t('qualitycheck.qualitycheck.success')">
          <v-radio
            :label="$t('global.true')"
            value="true"
          ></v-radio>
          <v-radio
            :label="$t('global.false')"
            value="false"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="productSelectItems"
          v-model="item.product"
          :items="productSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.qualitycheck.product')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="userSelectItems"
          v-model="item.userTesting"
          :items="userSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.qualitycheck.usertesting')"
          item-text="login"
          item-value="@id"
        />
      </v-col>
    </v-row>

    <v-row>
      <h3>{{ $t('qualitycheck.qualitycheck.start') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.start_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.start_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <h3>{{ $t('qualitycheck.qualitycheck.end') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.end_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.end_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import InputDate from '../InputDate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'QualityCheckFilter',
  components: {
    InputDate,
  },
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
      this.productGetSelectItems();
      this.userGetSelectItems();
  },

  computed: {
    ...mapFields('product', {
      productSelectItems: 'selectItems',
    }),
    ...mapFields('user', {
      userSelectItems: 'selectItems',
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      productGetSelectItems: 'product/fetchSelectItems',
      userGetSelectItems: 'user/fetchSelectItems'
    }),
  }
};
</script>
